export default "__VITE_ASSET__CK334CK3__"